const SETTINGS_COOKIE = "neptune_settings";
const LEGACY_SETTINGS_COOKIE = "settings";
const SETTINGS_COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

export const CALENDAR_VIEW_SETTING_KEY = "calendar_view";

const getCookieValue = (name) => {
  if (typeof document === "undefined") {
    return null;
  }

  const cookieEntry = document.cookie
    .split("; ")
    .find((entry) => entry.startsWith(`${name}=`));

  if (!cookieEntry) {
    return null;
  }

  return cookieEntry.substring(name.length + 1);
};

const parseSettingsValue = (rawValue) => {
  if (!rawValue) {
    return null;
  }

  try {
    const parsed = JSON.parse(decodeURIComponent(rawValue));
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
};

const readSettingsCookie = () => {
  const primaryRaw = getCookieValue(SETTINGS_COOKIE);
  if (primaryRaw !== null) {
    return {
      cookieName: SETTINGS_COOKIE,
      settings: parseSettingsValue(primaryRaw) ?? {},
    };
  }

  const legacyRaw = getCookieValue(LEGACY_SETTINGS_COOKIE);
  if (legacyRaw !== null) {
    return {
      cookieName: LEGACY_SETTINGS_COOKIE,
      settings: parseSettingsValue(legacyRaw) ?? {},
    };
  }

  return { cookieName: SETTINGS_COOKIE, settings: {} };
};

const writeSettingsCookie = (cookieName, value) => {
  if (typeof document === "undefined") {
    return;
  }

  document.cookie = `${cookieName}=${encodeURIComponent(
    JSON.stringify(value),
  )}; path=/; max-age=${SETTINGS_COOKIE_MAX_AGE}; samesite=lax`;
};

export const getAppSetting = (key, fallback = null) => {
  if (!key) {
    return fallback;
  }

  const { settings } = readSettingsCookie();
  if (!Object.prototype.hasOwnProperty.call(settings, key)) {
    return fallback;
  }

  return settings[key];
};

export const setAppSetting = (key, value) => {
  if (!key || typeof document === "undefined") {
    return;
  }

  const { cookieName, settings } = readSettingsCookie();
  writeSettingsCookie(cookieName, {
    ...settings,
    [key]: value,
  });
};
